import React, { useState } from "react";
import vedio from "../assets/images/vedio.png";
import DropdownRight from "./DropdownRight";
import HeaderLeft from "./HeaderLeft";
import { useSelector } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import GetStorage from "../services/Storage";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";

function AreYouSureUpload() {
  const video = useSelector((state) => state.video.video);
  const file = useSelector((state) => state.video.files);
  const id = useSelector((state) => state.video.id);
  const valueinput = useSelector((state) => state.input.inputvalue);
  // console.log("input value from redux", id);
  const navigate = useNavigate();
  const location = useLocation();
  const { camera } = location.state || {};
  const [error, setError] = useState("");
  const [value, setValues] = useState("0");
  const token = GetStorage.get("xAuthToken");
  const [url, setUrl] = useState("");
  const [uploadSpin, setUploadSpin] = useState(false);

  const validFormats = [
    "video/mp4",             // .mp4
    "video/quicktime",       // .mov
    "video/x-msvideo",       // .avi
    "video/x-ms-wmv",        // .wmv
    "video/x-flv",           // .flv
    "video/mpeg",            // .mpeg
    "video/x-matroska",      // .mkv
    "video/3gpp",            // .3gp
    "video/3gpp2",           // .3g2
    "video/ogg",             // .ogg
    "video/webm",            // .webm
    "video/vnd.sealed.mpeg4",// Sealed MPEG4
    "video/mp2t",            // .ts
  ];

  const handleUpload = () => {
    if(!validFormats.includes(file.type)){
      setError("Invalid file.");
      return;
    } else {
      setError("");
    }
    setUploadSpin(true);

    http
      .post(`api/analyst/s3video/evo?token=${token}`, {
        file_type: file.type,
        file_name: valueinput,
      })
      .then((res) => {
        const { url, key } = res.data.result;
        setUploadSpin(false);

        http.put(`api/analyst/work/submit?token=${token}`, {
          evo_path: key,
          order_id: id,
          camera: camera,
        });
        console.log("response", res.data);
        console.log(url, key);
        setUrl(key);
        fetch(url, {
          body: file,
          method: "PUT",
          headers: {
            "content-type": file.type,
            Accept: "*/*",
          },
        });
        // handleClose();
        navigate("/available");
      })
      .catch((error) => {
        setUploadSpin(false);

        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Are you sure?</h1>
          <p class="mb_40 them_para text-center mx-auto ">
            Are you sure you want to upload
            <span> {valueinput} </span>
            to your completed work folder? This action cannot be undone.
          </p>
          <div class="vedio">
            {" "}
            <video src={video} style={{ width: 400 }} controls download />{" "}
          </div>
          <p class="text-show-file  mt-2"> {valueinput} </p>
          <h6 style={{ color: "red" }}>{error}</h6>
          <div class="btn_wraper">
            <button
              type="button"
              class="them_btn mt_40 mb_30"
              onClick={() => navigate(-1)}
            >
              No, Select other
            </button>

            <button
              type="button"
              class="them_btn_ouline mt_40 mb_30 ml-2"
              onClick={handleUpload}
            >
              {uploadSpin ? (
                <SpinnerCircular className="button-spin" />
              ) : (
                " Yes, Upload Video"
              )}
            </button>
          </div>
        </div>
      </section>
    </>
  );
}

export default AreYouSureUpload;
